var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileFilled = function SvgProfileFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.305,74.7452 C69.973,66.3712 64.22,59.4552 56.521,56.4642 C61.28,53.5712 64.477,48.3522 64.477,42.3882 C64.477,33.3032 57.085,25.9112 48,25.9112 C38.915,25.9112 31.523,33.3032 31.523,42.3882 C31.523,48.3532 34.719,53.5712 39.479,56.4642 C31.78,59.4562 26.027,66.3712 24.695,74.7452 C17.23,68.2322 12.5,58.6612 12.5,48.0002 C12.5,28.4252 28.425,12.5002 48,12.5002 C67.575,12.5002 83.5,28.4252 83.5,48.0002 C83.5,58.6612 78.77,68.2322 71.305,74.7452 M48,8.5002 C26.22,8.5002 8.5,26.2192 8.5,48.0002 C8.5,69.7802 26.22,87.5002 48,87.5002 C69.78,87.5002 87.5,69.7802 87.5,48.0002 C87.5,26.2192 69.78,8.5002 48,8.5002",
    fill: "#000000",
    fillRule: "evenodd"
  })));
};
export default SvgProfileFilled;